import { createActions } from 'redux-actions';

export default createActions(
  {
    GET: (action) => action,
    SET: (action) => action,
    CREATE: (action) => action,
    DELETE: (action) => action,
    UPDATE: (action) => action,
    ADD_NOTE: (action) => action,
  },
  { prefix: 'Profile/JOB_SPECIALTY' }
);
